import { Outlet } from 'react-router-dom';
import { makeStyles, mergeClasses, tokens, Toaster, useId } from '@fluentui/react-components';
import { AdminBackendNavMenu } from '@shared/components/navigation/AdminBackendNavMenu.tsx';
import { Header } from '@shared/components/navigation/Header';
import { TenantBanner } from '@shared/components/navigation/TenantBanner';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: tokens.colorNeutralBackground2,
  },
  header: {
    backgroundColor: '#a40000', // Admin red header
  },
  container: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
  },
  sidebar: {
    width: '250px',
    flexShrink: 0,
    backgroundColor: '#1a1a1a',
    color: tokens.colorNeutralForegroundOnBrand,
    borderRight: `1px solid ${tokens.colorNeutralStroke1}`,
    overflowY: 'auto',
    '@media (max-width: 768px)': {
      display: 'none',
    },
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },
  main: {
    flex: 1,
    padding: tokens.spacingHorizontalXL,
    '@media (max-width: 768px)': {
      padding: tokens.spacingHorizontalM,
    },
  },
});

export function AdminLayout() {
  const styles = useStyles();
  const toasterId = useId('admin-toaster');

  return (
    <div className={styles.root}>
      {/* D-09 print contract — the sidebar and top bar disappear from the
          printed page via the existing global .no-print utility; no new
          print mechanism is introduced here. */}
      <div className="no-print">
        <Header isAdmin />
      </div>
      <div className={styles.container}>
        <nav className={mergeClasses(styles.sidebar, 'no-print')}>
          <AdminBackendNavMenu />
        </nav>
        <div className={styles.content}>
          <main className={styles.main}>
            <TenantBanner />
            <Outlet />
          </main>
        </div>
      </div>
      <Toaster toasterId={toasterId} position="top-end" />
    </div>
  );
}

export default AdminLayout;
